var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.4 13.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#848484;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.4,8V5.39H12a5.29,5.29,0,0,0-.71-1.65l1-1L10.62,1.15l-1,1a5.38,5.38,0,0,0-1.83-.76V0H5.57V1.35A5.19,5.19,0,0,0,3.93,2l-1-1L1,2.93l1,1a5.35,5.35,0,0,0-.6,1.46H0V8H1.39A5.61,5.61,0,0,0,2,9.52l-1,1,1.85,1.85,1-1a5.36,5.36,0,0,0,1.7.68V13.4H7.83V12.05a5.23,5.23,0,0,0,1.63-.64l1,1,1.95-1.95-1-1A5.59,5.59,0,0,0,12,8ZM8,8.86a2.53,2.53,0,0,1-.76.31H6.12a2.7,2.7,0,0,1-.77-.31L4.54,8a2.85,2.85,0,0,1-.32-.76V6.12a3.06,3.06,0,0,1,.32-.77l.81-.81a3.06,3.06,0,0,1,.77-.32H7.28A2.85,2.85,0,0,1,8,4.54l.82.81a2.7,2.7,0,0,1,.31.77V7.28A2.53,2.53,0,0,1,8.86,8Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCog);
export default __webpack_public_path__ + "static/media/cog.91b6e9c46596032a80a11adeaf4ff7dc.svg";
export { ForwardRef as ReactComponent };